import { API_BASE_URL } from 'src/globals';
import { FETCH_KYC } from 'src/api/routes';
import {
  GET,
} from 'src/api/apiHandler';

const fetchKYC = () => {
  return GET(`${API_BASE_URL}${FETCH_KYC}`);
};

export {
  fetchKYC,
};
